module.exports = __webpack_public_path__ + "img/logo-galeria-lodzka.4ed13012.png";